module.exports = __webpack_public_path__ + "img/UdeG_logo.8adde7cf.jpg";